import {RiotRawRealTimeParticipant, RiotCurrentGameRuneCount, default as RiotDB} from "./RiotDB";
import {SimRunes, ChampionRunes} from "./calculation/CalculationObjects";
import {SimStats} from "./calculation/SimStats";
import {IHash} from "./framework/CommonInterfaces";
import * as _ from 'lodash';
import Simulation from "./Simulation";
import GoogleSheetDB from "./GoogleSheetDB";
import FBOM from "./framework/FBOM";
import Player from "./Player";
import FullStoryManager from "./FullStoryManager";
import SimulationActions from "../actions/SimulationActions";

let shortid = require('shortid');


export interface CurrentGamePlayerInformation{
	summonerName:string;
	runes:ChampionRunes;
	champName:string;
}

export interface CurrentGameInformation{
	raw:RiotRawRealTimeParticipant[];
	players:IHash<CurrentGamePlayerInformation>;
	curPlayer:CurrentGamePlayerInformation;
	otherTeam:CurrentGamePlayerInformation[];

}

export interface AbilityImages{
	Q:string;
	W:string;
	E:string;
	R:string;
	P:string;
}


export class CurrentGameManager{

	static createChampionRunesFromSimStats(runeStats:SimStats):ChampionRunes{
		let ret:ChampionRunes = {
			runes:{
				name:"From Real Game"
			},
			riotName:null,
			when:"These runes were loaded directly from a real game",
			default:false,
		};

		SimStats.setStats(ret.runes,runeStats);
		return ret;
	}


	static convertRiotParticipant(riotP:RiotRawRealTimeParticipant):CurrentGamePlayerInformation{
		let runeStats = CurrentGameManager.convertRuneCountToSimStats(riotP.runes);

		return {
			champName:RiotDB.getChampionByKey(riotP.championId).name,
			summonerName:riotP.summonerName,
			runes:CurrentGameManager.createChampionRunesFromSimStats(runeStats)
		}
	}


	static convertRuneCountToSimStats(runeCounts:RiotCurrentGameRuneCount[]):SimStats{
		let simStats = SimStats.constructSimStats();
		for (let i = 0; i < runeCounts.length; i++) {
			let runeCount = runeCounts[i];
			let rune = RiotDB.getRuneById(runeCount.runeId);
			for (let j = 0; j < runeCount.count; j++) {
				SimStats.addRiotDataToSimStats(simStats, rune.stats);
			}
		}
		return simStats;
	}
}

export default class KillPageStore{

	static onChangeCallbacks:IHash<()=>void> = {};
	static curGamePlayerName:string ="";
	static curGameOpponentName:string="";
	static curGameData:CurrentGameInformation;
	static curSimulation:Simulation;
	static curMeChampAbilities:AbilityImages;
	static loading:boolean = false;
	static gameFound:boolean = false;



	static actionSetCurrentSimulation(sim:Simulation){
		KillPageStore.curSimulation = sim;
	}

	static actionPageLoadingStart(){
		FullStoryManager.init();

		let userName = KillPageStore.getUserName();
		if(userName != null){
			FullStoryManager.identify(userName,userName);
		}

	}


	static handleSimulationChange(sim:Simulation){
		return (async() => {

			console.log("sim changed",sim);

			await KillPageStore._loadAbilityIconsForChampionsP(sim);
			KillPageStore.emitOnChange();
		})();
	}

	static _loadAbilityIconsForChampionsP(sim:Simulation){
		return (async() => {
			let promises = [];

			if(sim.mePlayer == undefined){
				debugger;
			}

			if(sim.mePlayer.selectedChampion){
				promises.push(RiotDB.loadChampionAbilityIconsP(sim.mePlayer.selectedChampion))
			}

			if(sim.themPlayer.selectedChampion){
				promises.push(RiotDB.loadChampionAbilityIconsP(sim.themPlayer.selectedChampion))
			}
			await Promise.all(promises);
		})();
	}


	static actionLoadSimulation(history:any, simId:string){

		console.log("action loading simulation", simId);

		return (async() => {
			try {
				await Promise.all([RiotDB.loadP(),GoogleSheetDB.loadP()]);
				await SimulationActions.loadSimulationP(simId);
				FBOM.onObjectChange(simId, (simulation:Simulation)=>{this.handleSimulationChange(simulation)})
			}
			catch(e) {
				if (FBOM.getObject(simId) == undefined){
					return history.push('/simulation');
				}
				console.log(`error loading the simulation ${simId}`, e)
			}

			KillPageStore.curSimulation = FBOM.getObject(simId);


			FBOM.onObjectChange(KillPageStore.curSimulation.mePlayer.id,(simulation:Simulation)=>{KillPageStore.emitOnChange();});
			FBOM.onObjectChange(KillPageStore.curSimulation.themPlayer.id,(simulation:Simulation)=>{KillPageStore.emitOnChange();});


			await KillPageStore._loadAbilityIconsForChampionsP(KillPageStore.curSimulation);
			KillPageStore.emitOnChange();


		})();




	}

	static getUserName(){
		return localStorage.getItem('username');
	}


	static actionSetUsername(username:string){
		localStorage.setItem('username', username);
		FullStoryManager.identify(username,username);
		KillPageStore.emitOnChange();
	}

	static onChange(cb:()=>void):string{
		let id = shortid.generate();
		KillPageStore.onChangeCallbacks[id] = cb;
		return id;
	}

	static emitOnChange(){
		for(let key in KillPageStore.onChangeCallbacks){
			KillPageStore.onChangeCallbacks[key]();
		}
	}

	static removeOnChange(cbId:string){
		delete KillPageStore.onChangeCallbacks[cbId];
	}

	static actionSetLoading(){
		KillPageStore.loading = !KillPageStore.loading;
		KillPageStore.emitOnChange();
	}

	static actionLookupCurrentGame(playerName:string, region:string="na1"){
		(async() => {
			KillPageStore.curGamePlayerName = playerName;
			KillPageStore.actionSetLoading();
			let currentGameInfoRaw:RiotRawRealTimeParticipant[] = await RiotDB.getCurrentGameInfoP(playerName,region);
			if(currentGameInfoRaw.length == 0){
				//TODO replace this with something better.
				KillPageStore.gameFound = false;
				KillPageStore.actionSetLoading();
				return null;
			}


			let currentGameInfo:CurrentGameInformation = {
				raw:currentGameInfoRaw,
				curPlayer:undefined,
				otherTeam:[],
				players:{}
			};


			//keep track of my team
			let meTeam;


			//Convert everyone and map them
			for (let i = 0; i < currentGameInfoRaw.length; i++) {
				let pRaw = currentGameInfoRaw[i];
				let participant:CurrentGamePlayerInformation = CurrentGameManager.convertRiotParticipant(pRaw);

				if(participant.summonerName.toLowerCase() == playerName.toLowerCase()){
					currentGameInfo.curPlayer = participant;
					meTeam = pRaw.teamId;
				}

				currentGameInfo.players[participant.summonerName.toLowerCase()] = participant;
			}


			//Now grab the other team
			for (let i = 0; i < currentGameInfoRaw.length; i++) {
				let pRaw = currentGameInfoRaw[i];

				if(pRaw.teamId != meTeam){
					currentGameInfo.otherTeam.push(currentGameInfo.players[pRaw.summonerName.toLowerCase()])
				}
			}



			console.log(`searched for ${playerName} and converted results to`,currentGameInfo);
			KillPageStore.curGameData = currentGameInfo;

			if (KillPageStore.curGameOpponentName == ""){
				KillPageStore.curGameOpponentName = currentGameInfo.otherTeam[0].summonerName;
			}

			KillPageStore.actionSelectThemFromCurrentGame(KillPageStore.curGameOpponentName);
			KillPageStore.updatePlayerFromCurGame(KillPageStore.curSimulation.mePlayer,currentGameInfo.curPlayer);
			await KillPageStore._loadAbilityIconsForChampionsP(KillPageStore.curSimulation);
			KillPageStore.emitOnChange();
			KillPageStore.gameFound = true;
			KillPageStore.actionSetLoading();
			return null;
		})();
	}

	static getCurGameLookupStatus(){
		return KillPageStore.gameFound;
	}
	static getCurGamePlayerName(){
		return KillPageStore.curGamePlayerName;
	}

	static updatePlayerFromCurGame(fbPlayer:Player, curGamePlayer:CurrentGamePlayerInformation){
		fbPlayer.selectedChampion = curGamePlayer.champName;
		fbPlayer.selectedRunes = curGamePlayer.runes;
		fbPlayer.selectedSkillOrder = GoogleSheetDB.getDefaultSkillOrdersForChampion(fbPlayer.selectedChampion);
		FBOM.rSaveP(fbPlayer);

	}

	static actionSelectThemFromCurrentGame(playerName:string){
		(async() => {
			KillPageStore.curGameOpponentName = playerName;
			KillPageStore.updatePlayerFromCurGame(KillPageStore.curSimulation.themPlayer,KillPageStore.curGameData.players[playerName.toLowerCase()]);
			await KillPageStore._loadAbilityIconsForChampionsP(KillPageStore.curSimulation);
			KillPageStore.emitOnChange();
		})();

	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/fbobjects/KillPageStore.ts